module.exports = __webpack_public_path__ + "img/home_icon_signup@2x.2006e8e3.png";